module.exports = __webpack_public_path__ + "static/media/logo.0cd61410.svg";